import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser, refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) { navigate("/", { replace: true }); return; }
    (async () => {
      try {
        await axios.post(`${API}/auth/session`, { session_id: sid }, { withCredentials: true });
        await refresh();
        window.history.replaceState({}, "", "/");
        navigate("/", { replace: true });
      } catch (e) {
        setUser(null);
        navigate("/?auth_error=1", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh, setUser]);

  return (
    <div className="min-h-screen bg-[#050811] text-[#E2CFA4] flex flex-col items-center justify-center gap-4">
      <Loader2 size={36} className="animate-spin text-[#C1A661]" />
      <div className="text-[11px] tracking-[0.3em] uppercase">Signing you in…</div>
    </div>
  );
};

export default AuthCallback;
